// extracted by mini-css-extract-plugin
export var circle_icon = "Caracteristicas-module--circle_icon--de957";
export var container = "Caracteristicas-module--container--a4187";
export var container_icons = "Caracteristicas-module--container_icons--31ee4";
export var container_info = "Caracteristicas-module--container_info--e879a";
export var container_text = "Caracteristicas-module--container_text--a5599";
export var icon = "Caracteristicas-module--icon--cbe35";
export var main_section8 = "Caracteristicas-module--main_section8--c1169";
export var text = "Caracteristicas-module--text--e2319";
export var title = "Caracteristicas-module--title--85d7f";